var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPaymentFailed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 57,
    height: 56,
    viewBox: "0 0 57 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.97 0.53C32.98 0.34 31.99 0.25 31 0.11C30.9 0.09 30.81 0.04 30.71 0C29.15 0 27.59 0 26.04 0C25.43 0.1 24.83 0.21 24.22 0.31C16.45 1.52 10.21 5.24 5.51 11.41C2.4 15.5 0.66 20.13 0.12 25.19C0.11 25.32 0.04 25.45 0 25.58C0 27.15 0 28.71 0 30.28C0.1 30.88 0.21 31.47 0.31 32.07C2.02 41.96 7.45 49.2 16.69 53.41C33.25 60.96 52.64 51.24 56.39 33.66C59.64 18.47 49.52 3.52 33.97 0.53ZM36.27 31.32C37.81 32.74 39.35 34.17 40.88 35.59C39.33 37.11 37.79 38.64 36.24 40.16C33.64 37.61 31.07 35.08 28.49 32.55C25.92 35.08 23.34 37.6 20.74 40.16C19.19 38.64 17.65 37.11 16.1 35.59C17.64 34.17 19.18 32.74 20.71 31.32C21.81 30.24 22.88 29.19 23.97 28.12C21.33 25.53 18.7 22.95 16.1 20.39C17.52 18.91 18.98 17.39 20.49 15.83C23.16 18.45 25.82 21.07 28.49 23.69C31.16 21.07 33.82 18.46 36.49 15.83C38 17.4 39.46 18.92 40.88 20.39C38.28 22.95 35.65 25.53 33.01 28.12C34.1 29.19 35.18 30.24 36.27 31.32Z",
    fill: "#FF3131"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaymentFailed);
export default __webpack_public_path__ + "static/media/payment-failed.51c4d3acecdec3728875eaa30f0156f8.svg";
export { ForwardRef as ReactComponent };